/**
 * Reducer for all global activities (e.g. notifications)
 */
import NotificationsConstants from '../constants/NotificationsConstants';
import DevAuthConstants from '../constants/DevAuthConstants';
import RoutesConstants from '../constants/RoutesConstants';
import GlobalConstants from '../constants/GlobalConstants';
import FlightsConstants from '../constants/FlightsConstants';
import PassengerConstants from '../constants/PassengerConstants';
import PassengersConstants from '../constants/PassengersConstants';
import RelationshipTypesConstants from '../constants/RelationshipTypesConstants';
import { fromJS, List as IList, Map as IMap } from 'immutable';
import AllFlightsConstants from '../constants/AllFlightsConstants';
// import update from 'react-addons-update';

const initialState = fromJS(
  IMap({
    isFetching: false,
    activePassenger: '',
    notifications: IList(),
    reservationId: 0,
    activeStep: 'flights',
  })
);

/**
 * ## global function
 * @param {Object} state - initialState
 * @param {Object} action - type and data
 */
export default function global (state = initialState, action = null) {
  let errorMessage = action && action.data && action.data.message ? action.data.message : null;
  let newState;

  switch (action.type) {
    /**
     * ### REQUEST (start of request)
     */
    case AllFlightsConstants.ALL_FLIGHTS_REQUEST:
    case DevAuthConstants.DEV_AUTH_REQUEST:
    case RoutesConstants.ROUTES_REQUEST:
    case FlightsConstants.GET_FLIGHTS_REQUEST:
    case RelationshipTypesConstants.RELATIONSHIP_TYPES_REQUEST:
    case PassengerConstants.PASSENGER_REQUEST:
    case PassengerConstants.SAVE_PASSENGER_REQUEST:
    case PassengersConstants.PASSENGERS_REQUEST:
      return state.set('isFetching', true);

    /**
     * ### SUCCESS (requests ended with success)
     */
    case NotificationsConstants.NOTIFICATIONS_SUCCESS:
      return state.set('notifications', IList(action.data));

    case DevAuthConstants.DEV_AUTH_SUCCESS:
      newState = state.set(
        'notifications',
        IList([
          {
            type: NotificationsConstants.NOTIFICATION_SUCCESS,
            description: 'Successfully fetched session token',
          },
        ])
      );

      return newState.set('isFetching', false);

    case RoutesConstants.ROUTES_SUCCESS:
    case AllFlightsConstants.ALL_FLIGHTS_SUCCESS:
    case RelationshipTypesConstants.RELATIONSHIP_TYPES_SUCCESS:
    case PassengerConstants.PASSENGER_SUCCESS:
    case PassengerConstants.SAVE_PASSENGER_SUCCESS:
    case PassengersConstants.PASSENGERS_SUCCESS:
    case FlightsConstants.GET_FLIGHTS_SUCCESS:
      return state.set('isFetching', false);

    /**
     * ### FAILURE (requests ended with error)
     */
    case DevAuthConstants.DEV_AUTH_FAILURE:
      newState = state.set(
        'notifications',
        IList([
          {
            type: NotificationsConstants.NOTIFICATION_ERROR,
            description: errorMessage || 'Failed to fetch session token',
          },
        ])
      );

      return newState.set('isFetching', false);

    case RoutesConstants.ROUTES_FAILURE:
      newState = state.set(
        'notifications',
        IList([
          {
            type: NotificationsConstants.NOTIFICATION_ERROR,
            description: errorMessage || 'Failed to fetch flight routes',
          },
        ])
      );
      return newState.set('isFetching', false);

    case AllFlightsConstants.ALL_FLIGHTS_FAILURE:
      newState = state.set(
        'notifications',
        IList([
          {
            type: NotificationsConstants.NOTIFICATION_ERROR,
            description: errorMessage || 'Failed to fetch all flights',
          },
        ])
      );
      return newState.set('isFetching', false);

    case FlightsConstants.GET_FLIGHTS_FAILURE:
      newState = state.set(
        'notifications',
        IList([
          {
            type: NotificationsConstants.NOTIFICATION_ERROR,
            description: errorMessage || 'Failed to fetch all flights',
          },
        ])
      );
      return newState.set('isFetching', false);

    case RelationshipTypesConstants.RELATIONSHIP_TYPES_FAILURE:
      newState = state.set(
        'notifications',
        IList([
          {
            type: NotificationsConstants.NOTIFICATION_ERROR,
            description: errorMessage || 'Failed to fetch all relationship types',
          },
        ])
      );
      return newState.set('isFetching', false);

    case PassengerConstants.SAVE_PASSENGER_FAILURE:
      newState = state.set(
        'notifications',
        IList([
          {
            type: NotificationsConstants.NOTIFICATION_ERROR,
            description: errorMessage || 'Failed to save passenger/contact',
          },
        ])
      );
      return newState.set('isFetching', false);

    case PassengerConstants.PASSENGER_FAILURE:
      newState = state.set(
        'notifications',
        IList([
          {
            type: NotificationsConstants.NOTIFICATION_ERROR,
            description: errorMessage || 'Failed to fetch selected passenger/contact',
          },
        ])
      );
      return newState.set('isFetching', false);

    case PassengersConstants.PASSENGERS_FAILURE:
      newState = state.set(
        'notifications',
        IList([
          {
            type: NotificationsConstants.NOTIFICATION_ERROR,
            description: errorMessage || 'Failed to fetch all contacts/passengers',
          },
        ])
      );
      return newState.set('isFetching', false);

    /**
     * ### CUSTOM REQUEST (client only)
     */
    case GlobalConstants.DISMISS_NOTIFICATION:
      let notifications = state.get('notifications').toJS();
      if (notifications) {
        let dismissedNotification = notifications.find(
          notification => notification === action.data
        );
        if (dismissedNotification) {
          let dismissedNotificationIndex = notifications.indexOf(dismissedNotification);
          notifications.splice(dismissedNotificationIndex, 1);
        }
      }
      return state.set('notifications', IList(notifications));

    case GlobalConstants.CHANGE_ACTIVE_PASSENGER:
      return state.set('activePassenger', action.data || '');

    case GlobalConstants.CHANGE_ACTIVE_STEP:
      return state.set('activeStep', action.data || '');

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/GlobalReducer.js